import Router from 'next/router';
import { stringify } from 'qs';

import { EProductsId } from '@r1-frontend/shared/types/EProductsId';

import { fullBuyEquipAnalyticsBase } from '~/src/analytics';

interface Installment {
    value: number,
    label: string,
    price: number,
}

interface IItem {
    globalId: number,
    title: string,
    alias: string,
}

type TOrderHandlerParameters = {
    item: IItem,
    installment: Installment,
    deliveryId: string,
    testDrive: number,
    category: string,
    productId: EProductsId,
    requestId?: number,
}

/**
 * Роутинг на страницу оформления доствки почтой или через инженера
 */
 const orderHandler = ({
    item,
    installment,
    deliveryId,
    testDrive,
    category,
    productId,
    requestId,
 }: TOrderHandlerParameters) => {
    const { globalId: ensId, title, alias } = item;
    const { value: duration = 0, price } = installment;

    const byEngeneer = `/full-buy-equip?${stringify({
        ensId,
        productId,
        duration,
        category,
        deliveryId,
        testDrive,
        requestId,
    })}`;

    const byPost = `/lk/purchase/${category}/${alias}?duration=${duration}`;

    const route = deliveryId === 'post' ? byPost : byEngeneer;

    Router.push(route);

    fullBuyEquipAnalyticsBase.clickOrderDetails({
        equipmentTitle: title,
        category,
        leasing: duration,
        cost: price,
        testDrive,
    });
};

/**
 * Возвращает обработчик с заданной категорией продукта и типом
 * @param category тип продукта из EShopCategory (приставка, роутер, яндекс-станция)
 * @param productId условные типы продукта EProductsId (интернет, тв)
 * @returns функция
 */
 export const getOrderHandler =
    (category: string, productId: EProductsId) =>
    (
        item: IItem,
        installment: Installment,
        deliveryId: string,
        testDrive: number,
        requestId?: number,
    ) => {
        orderHandler({
            item,
            installment,
            deliveryId,
            testDrive,
            category,
            productId,
            requestId,
        });
    };
